module.exports = __webpack_public_path__ + "assets/img/busy_8.b91608ab.png";